import { useState } from "react";

import { Modal } from "../Modal";
import { ClassCodeForm } from "./ClassCodeForm";

export const ClassCode: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      Have a class code?{" "}
      <button
        onClick={() => {
          setIsModalOpen(true);
        }}
        className="link"
      >
        Click here
      </button>
      <Modal
        size="sm"
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
      >
        <ClassCodeForm />
      </Modal>
    </>
  );
};
